// POC testers - add emails here to enable tabbed home page
export const POC_TESTER_EMAILS: string[] = ['jpk@trainingtube.com']

export function isPocTester(email: string): boolean {
  if (!email) return false
  return POC_TESTER_EMAILS.map((e) => e.toLowerCase()).includes(email.toLowerCase())
}
